

export const API = {
  requestOtp: '/auth/register/otp/request',
  submitOtp: '/auth/register/otp/submit',
  keepAlive: '/auth/keep_alive',
  getCategory: '/category?level=1',
  getAllCategory: '/category?level=0',
  registerFactory: '/factory/register',
  registerAgent: '/agent/register',
  masterProvice: '/master/provinces',
  masterDistrict: '/master/districts?province_id=',
  masterSubDistrict: '/master/subdistricts?district_id=',
  masterProperty: '/master/property-labels',
  requestAuthOtp: '/auth/login',
  submitAuthOtp: '/auth/login/confirm',
  authLoginPassword: '/auth/login_user',
  changePassword: '/user/admin/change_password',
  authProfile: '/auth/profile',
  getNewOder: '/factory/orders/new_order',
  makeappointment: '/factory/orders/makeappointment',
  getWaitingShip: '/factory/orders/wait_ship',
  getOrderComplete: '/factory/orders/complete',
  getOrderInprocess: '/factory/orders/inprocess',
  getOrderCancel: '/factory/orders/cancel',
  getPendingsku : '/factory/orders/pendingsku',
  getWaitingRefund: '/factory/orders/wait_approve_refund',
  updateApproveRequestCancel: '/factory/orders/update_request_cancel',
  updateDeleteRequestCancel: '/factory/orders/delete_request_cancel',
  createProduct: '/product',
  getProductList: '/factory/products/find',
  deleteProduct: '/product/',
  getProductById: '/product/',
  updateStatusProduct: '/product/updateStatus',
  getAgentsList: '/factory/contacts_wallet',
  getAgentById: '/factory/contacts/',
  updateFactory: '/factory/update_factory',
  updateUserProfile: '/factory/update_contact_factory',
  masterZipcode: '/master/sub_districts_id_by_zip_code?zip_code=',
  masterRetailType: '/master/master_by_process/retail_type',
  getReportOverview: '/factory/report/overview',
  getReportOverviewCancel: '/factory/report/count_cancel_report',
  getReportOverviewInprogress: '/factory/report/count_inprogress_report',
  getReportOverviewComplete: '/factory/report/count_complete_report',
  getReportOverviewOpen: '/factory/report/count_open_report',
  getReportTopSale: '/factory/report/topsale_report',
  getIncomeChart: '/factory/report/cpmpare_profit_report',
  getNotification: '/push-notification/load_all',
  updateReadNotification: '/push-notification/update_read',
  cancelHandshake: '/factory/cancel_handshake',
  orderProductSku: '/factory/orderproductsku/load_all',
  updateCapacity: '/factory/orderproductsku/create_capacity',
  submitNewOrder: '/factory/orders/submit_order',
  getOrderThaipost: '/factory/orders/data/thaipost',
  getExportOrderToThaiPost: '/factory/orders/data/export_order_thaipost',
  getTokenLine: '/factory/line/load_token',
  updateTokenLine: '/factory/line/add_token',
  testMessageLine: '/factory/line/test_message',
  getOrderproductskuNewOrder: '/factory/orderproductsku/load_order',
  makeOrderConfirm: '/factory/orderproductsku/submit_order_sku',
  getLoadNewOrderSku: '/factory/orderproductsku/load_order_sku',
  createOrderTransaction: '/factory/orderproductsku/create_order_transection',
  rollbackOrderTransaction: '/factory/orderproductsku/rollback_order_transection',
  getOrderDistributed: '/factory/orderproductsku/',
  getOrderDistributedList: '/factory/orderproductsku/order_transaction_list',
  getDetailLotTransaction: '/factory/orderproductsku/order_lot_transection_detail',
  getOlderLotTransaction : '/factory/orderproductsku/order_lot_transection',
  getExportOrderTransafer: '/factory/orders/export_order_tranfer',
  getDcAllList: '/dc/load_all',
  exportAgentList: '/factory/export_contacts_wallet',
  deleteAgentImmediately: '/factory/delete_agent_user',
  getUserRoleWithoutAdmin: '/user/role_no_systemadmin',
  getUserSystem: '/factory/load_user_factory',
  createUserSystem: '/factory/create_user_factory',
  deleteUserSystem: '/factory/delete_user_factory',
  updateUserSystem: '/factory/update_user_factory',
  getFactoryDataById: '/factory/',
  getFactoryDataNonAuthen: '/factory/get_data_nonauthen',
  getCampaignRewardTypes: '/campaign/reward/types',
  getCampaignConditionTypes: '/campaign/condition/types',
  createCampaign: '/campaign/create',
  getCampaignList: '/campaign/load-all',
  getCampaignById: '/campaign/load/',
  updateCampaign: '/campaign/update',
  createFactoryTaxInvoice: '/factory/tax_invoice/create',
  updateFactoryTaxInvoice: '/factory/tax_invoice/update',
  // factory/department-stock
  listDepartmentMaster: '/factory/department-stock/departments/master',
  getFactoryStore: '/factory/department-stock/factory-store',
  getDepartmentStore: '/factory/department-stock/department-store/',
  getDepartmentStockOverview: '/factory/department-stock/',
  listDepartmentWarehouses: '/factory/department-stock/',
  ensureDepartmentWarehouse: '/factory/department-stock/ensure-warehouse/',
  distributeDepartmentStock: '/factory/department-stock/distribute',
  // inventory
  getLotBatchCodesWithStock: '/inventory/lot-batch-codes/with-stock',
  getInventoryMovements: '/inventory/movement',
}

